import { actions } from './actions';

const DismissionReportReducer = {
    [actions.APPLY_SELECTED_DISMISSION_REPORT]: (state, action) => { return { ...state, selectedDismissionReport: action.selectedDismissionReport } },
}

export default DismissionReportReducer;